import InputIconByKey from '../../../../components/Forms/Input/InputIconByKey';
import { IconKey } from '../../../../types/system/icons';
import { RestaurantMenuCategoryDTO } from '../../../../types/restaurant/RestaurantMenuTypes';
import MenuCategoryActions from './MenuCategoryActions';

interface MenuCategoryCardProps {
  category: RestaurantMenuCategoryDTO;
  onEdit: (category: RestaurantMenuCategoryDTO) => void;
  onToggle: (category: RestaurantMenuCategoryDTO) => void;
}

const MenuCategoryCard = ({
  category,
  onEdit,
  onToggle,
}: MenuCategoryCardProps) => {
  return (
    <article
      className={`rounded-xl border border-stroke bg-white p-5 transition hover:border-primary/30 hover:shadow-default dark:border-strokedark dark:bg-boxdark ${
        category.active ? '' : 'opacity-60'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 gap-3">
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border"
            style={{
              backgroundColor: `${category.color || '#3C50E0'}1a`,
              borderColor: `${category.color || '#3C50E0'}40`,
              color: category.color || '#3C50E0',
            }}
          >
            <InputIconByKey
              iconKey={(category.icon as IconKey) || 'utensils'}
              className="h-5 w-5"
            />
          </span>

          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-bodydark2">
              {category.code}
            </p>

            <h3 className="mt-1 truncate font-semibold text-black dark:text-white">
              {category.name}
            </h3>
          </div>
        </div>

        <span
          className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-medium ${
            category.active
              ? 'bg-success/10 text-success'
              : 'bg-danger/10 text-danger'
          }`}
        >
          {category.active ? 'Activa' : 'Inactiva'}
        </span>
      </div>

      <p className="mt-5 min-h-[42px] text-sm text-bodydark2 dark:text-bodydark">
        {category.description || 'Sin descripción.'}
      </p>

      <div className="mt-4 flex gap-2 border-t border-stroke pt-4 dark:border-strokedark">
        <MenuCategoryActions
          category={category}
          onEdit={onEdit}
          onToggle={onToggle}
        />
      </div>
    </article>
  );
};

export default MenuCategoryCard;
